/** Whether Forma's side panel stands open or folds to its 64px rail (canon FV6-03 to FV6-07). */

import { newestClip, type ClipEntry } from '~/entities/exercise-clip';
import type { PreferenceStore } from '~/shared/lib/preferenceStore';

import { readTrainerFlag, writeTrainerFlag } from './trainerFlag';

export interface DockPanelInput {
  readonly pinned: boolean;
  /** The trainer's own open or close for this visit, or `null` when they have not touched it. */
  readonly toggle: boolean | null;
  /** The automatic answer for this movement, fixed when its recordings were first known. */
  readonly latched: boolean | null;
}

/**
 * Pinned open wins, then the trainer's toggle, then the latched answer; `null` while none of them
 * has spoken. The list row cannot stand in: it is marked when ANY recording is unwatched, and the
 * panel opens only for the newest.
 */
export function dockPanelOpen({ pinned, toggle, latched }: DockPanelInput): boolean | null {
  if (pinned) return true;
  return toggle ?? latched;
}

/**
 * The automatic answer once the recordings are known: the newest one is unwatched. Latched per
 * movement by the caller, because watching the clip clears the very mark it opened on.
 */
export function opensOnItsOwn(clips: readonly ClipEntry[]): boolean {
  return newestClip(clips)?.unread === true;
}

const PINNED_KEY = 'movebuddy.forma.dockPinned';

export function readDockPinned(store: PreferenceStore | null, trainerId: string | null): boolean {
  return readTrainerFlag(store, PINNED_KEY, trainerId);
}

export function writeDockPinned(store: PreferenceStore | null, trainerId: string | null, on: boolean): void {
  writeTrainerFlag(store, PINNED_KEY, trainerId, on);
}
